import React from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import TimeLabels from './TimeLabels'

import style from './style.css'

export default class CursorTimeIndicator extends React.Component {
  
  constructor( props ) {
    super( props )
    this.state = { cursorTime : null }
  }
  
  render() {
    const { cursorTime } = this.state

    return (
      <div className={style.cursorTimeIndicator}>{cursorTime != null ? TimeLabels.labelFor( cursorTime, true ) : '' }</div>
    )
  }

}
